import axios from "axios";
import axiosInstance from "./apiinterseptor"; // Corrected import path
import { toast } from "react-toastify"; // Make sure this import exists
import Cookies from "js-cookie"; // Add this import if not already present
type CompanyData = {
  name: string;
  email: string;
  phone: string;
  spocDetails: Array<{
    name: string;
    email: string;
    phone: string;
  }>;
  logo?: File;
  gstNo?: string;
  registeredAddress?: string;
  operationalAddress?: string;
  referredByFbdeUserId?: string;
};

export const createCompany = async (formData: FormData) => {
  try {
    console.log("Sending FormData to create company API");
    
    // Debug FormData contents
    console.log("FormData contents being sent to API:");
    for (let pair of formData.entries()) {
      if (pair[1] instanceof File) {
        console.log(pair[0] + ':', `File: ${pair[1].name} (${pair[1].size} bytes)`);
      } else {
        console.log(pair[0] + ':', pair[1]);
      }
    }

    const response = await axiosInstance.post('/companies/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    console.log("Company created successfully:", response.data);
    toast.success("Company created successfully");
    return response.data;
  } catch (error: any) {
    console.error("Failed to create company:", error.response?.data?.message);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    // Log the actual error details for debugging
    if (error.response?.data?.error) {
      console.error("Backend error details:", error.response.data.error);
    }
    
    toast.error(`Failed to create company: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};

// Get all companies with pagination and filtering
export const getAllCompanies = async (params: {
    page?: string;
    limit?: string;
    search?: string;
    userId?: string;
    companyType?: 'all' | 'external' | 'internal';
} = {}) => {
    try {
        const queryParams = new URLSearchParams();
        
        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.search) queryParams.append('search', params.search);
        if (params.userId) queryParams.append('userId', params.userId);
        if (params.companyType) queryParams.append('companyType', params.companyType);
        
        const apiUrl = `/companies?${queryParams.toString()}`;
        console.log("Fetching companies from:", apiUrl);
        
        const response = await axiosInstance.get(apiUrl);
        
        console.log("Fetched all companies response:", response.data);
        return response.data;
    } catch (error: any) {
        console.error("Failed to fetch companies:", error.response?.data?.message);
        toast.error(`Failed to fetch companies: ${error.response?.data?.message || 'Unknown error'}`);
        throw error;
    }
};

// Add this interface for the selection response
interface ICompanySelectionItem {
  id: string;
  name: string;
  logoUrl?: string;
  isExternalCompany?: boolean;
}

interface IGetCompanyListResponse {
  status: string;
  data: {
    companies: ICompanySelectionItem[];
  };
}

// Update the getCompanyListForSelection function to use the correct endpoint
export const getCompanyListForSelection = async (isExternalCompany?: boolean): Promise<IGetCompanyListResponse> => {
  try {
    console.log("Fetching company list for selection...", { isExternalCompany });
    
    // Build query params
    const params = new URLSearchParams();
    if (isExternalCompany !== undefined) {
      params.append('isExternalCompany', String(isExternalCompany));
    }
    
    const queryString = params.toString();
    const url = `/companies/list-for-selection${queryString ? `?${queryString}` : ''}`;
    
    console.log("Requesting companies from:", url);
    const response = await axiosInstance.get(url);
    
    console.log("Company selection list fetched successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch company selection list:", error.response?.data?.message);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    // Handle authorization errors specifically
    if (error.response?.status === 403) {
      toast.error("Access denied. Only administrators can access company lists.");
    } else {
      toast.error(`Failed to fetch companies: ${error.response?.data?.message || 'Unknown error'}`);
    }
    throw error;
  }
};

// Update company
export type UpdateCompanyData = {
  name?: string;
  email?: string;
  phone?: string;
  spocDetails?: Array<{
    name: string;
    email: string;
    phone: string;
  }>;
  logo?: File | string;
  logoUrl?: string;
  gstNo?: string;
  registeredAddress?: string;
  operationalAddress?: string;
  referredByFbdeUserId?: string;
};

export const updateCompany = async (companyId: string, updateData: UpdateCompanyData) => {
  try {
    console.log("Updating company with ID:", updateData);
    
    let requestData:  UpdateCompanyData;
    let headers: any = {};

    
      requestData = updateData;
      headers['Content-Type'] = 'application/json';
      console.log("JSON data being sent:", requestData);
    

    const response = await axiosInstance.put(`/companies/${companyId}`, updateData, {
      headers,
    });

    console.log("Company updated successfully:", response.data);
    toast.success("Company updated successfully");
    return response.data;
  } catch (error: any) {
    console.error("Failed to update company:", error.response?.data?.message);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    toast.error(`Failed to update company: ${error.response?.data?.message || 'Unknown error'}`);
    throw error;
  }
};


export const getCompanyProfile = async (id: string): Promise<any> => {
  try {
    console.log("Fetching company list for selection...");
    
    // Updated to match your backend route
    const response = await axiosInstance.get(`/companies/${id}/profile`);
    
    console.log("Company selection list fetched successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch company selection list:", error.response?.data?.message);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    // Handle authorization errors specifically
    if (error.response?.status === 403) {
      toast.error("Access denied. Only administrators can access company lists.");
    } else {
      toast.error(`Failed to fetch companies: ${error.response?.data?.message || 'Unknown error'}`);
    }
    throw error;
  }
};




interface Job {
  id: string;
  title: string;
  status: string;
  location: string;
  employmentType: string;
  workType: string;
  noOfOpenings: number;
  createdAt: string;
  totalApplicants: number;
  activeApplicants: number;
}

interface Application {
  candidate: {
    id: string;
    name: string;
    fatherName: string;
    email: string;
    phone: string;
  };
  job: {
    id: string;
    title: string;
  };
  applicationId: string;
  companyLocation: string;
  currentStatus: string;
  interviewDate: string;
  joinedOrOfferedDate?: string;
  tenure: {
    status: string;
    daysLeft: number | null;
    isApproved?: boolean;
  };
  ledBy: {
    id: string;
    username: string;
  };
}

interface Earning {
  applicationId: string;
  candidateId: string;
  candidateName: string;
  email: string;
  phone: string;
  employeeId: string;
  positionName: string;
  salary: number;
  commissionReceived: number;
  companyLocation: string;
  lastInterviewDate: string;
  joiningDate: string;
}

interface ApiResponse<T> {
  status: string;
  data: T;
  page?: number;
  limit?: number;
  totalPages?: number;
  totalResults?: number;
  summary?: { totalEarningsReceived: number };
}

export const getCompanyJobOpenings = async (id: string, params?: { page: number; limit: number }): Promise<ApiResponse<{ jobs: Job[] }>> => {
  try {
    console.log("Fetching company job openings...", { id, params });
    
    const response = await axiosInstance.get(`/companies/${id}/jobs`, { params });
    
    console.log("Company job openings fetched successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch company job openings:", error.response?.data?.message);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    if (error.response?.status === 403) {
      toast.error("Access denied. Only administrators can access company job openings.");
    } else {
      toast.error(`Failed to fetch job openings: ${error.response?.data?.message || 'Unknown error'}`);
    }
    throw error;
  }
};

export const getApplicationsByCompany = async (
  id: string,
  params?: {
    page: number;
    limit: number;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
    status?: string;
  }
): Promise<ApiResponse<{ applications: Application[] }>> => {
  try {
    console.log("Fetching company applications...", { id, params });
    
    const response = await axiosInstance.get(`/companies/${id}/candidates`, { params });
    
    console.log("Company applications fetched successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch company applications:", error.response?.data?.message);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    if (error.response?.status === 403) {
      toast.error("Access denied. Only administrators can access company applications.");
    } else {
      toast.error(`Failed to fetch applications: ${error.response?.data?.message || 'Unknown error'}`);
    }
    throw error;
  }
};

export const getApplicationsByCompanyExport = async (
  id: string,
  params?: {
    page: number;
    limit: number;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
    status?: string;
  }
): Promise<ApiResponse<{ applications: Application[] }>> => {
  try {
    
    const response = await axiosInstance.get(`/companies/${id}/candidates/export`, { params });
    
    console.log("Company applications fetched successfully for export:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch company applications for export::", error.response?.data?.message);
    console.error("Full error response for export:", error.response?.data);
    console.error("Error status for export:", error.response?.status);
    
    if (error.response?.status === 403) {
      toast.error("Access denied. Only administrators can access company applications.");
    } else {
      toast.error(`Failed to fetch applications: ${error.response?.data?.message || 'Unknown error'}`);
    }
    throw error;
  }
};

export const getCompanyEarnings = async (id: string, params?: { page: number; limit: number }): Promise<ApiResponse<{ earnings: Earning[] }>> => {
  try {
    console.log("Fetching company earnings...", { id, params });
    
    const response = await axiosInstance.get(`/companies/${id}/earnings`, { params });
    
    console.log("Company earnings fetched successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch company earnings:", error.response?.data?.message);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    if (error.response?.status === 403) {
      toast.error("Access denied. Only administrators can access company earnings.");
    } else {
      toast.error(`Failed to fetch earnings: ${error.response?.data?.message || 'Unknown error'}`);
    }
    throw error;
  }
};

export const publicCompanies = async (params?: { page: number; limit: number })=> {
  try {
    console.log("Fetching public companies...", { params });
    const response = await axiosInstance.get(`/publicCompanies`, { params });
    console.log("Public companies fetched successfully:", response.data);
     return response.data;
  }
    catch (error: any) {
    console.error("Failed to fetch public companies:", error.response?.data?.message);
    }
  
}
export const changeCompanyStatus = async (id:string,status:boolean) => {
  try {
    console.log("Changing company status...", { id, status });
    const response = await axiosInstance.patch(`/publicCompanies/changeStatus/${id}`,{status});
    console.log("Company status changed successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Failed to change company status:", error.response?.data);
    console.error("Full error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    
    // Extract the actual error message from the response
    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.error || 
                        error.message || 
                        'Failed to change company status';
    
    // Don't show toast here - let the calling function handle it with the actual error message
    // Re-throw the error with the message attached
    const errorWithMessage = new Error(errorMessage);
    (errorWithMessage as any).response = error.response;
    throw errorWithMessage;
  }
}
export const createCompanyOnboarding = async (onboardingData:any) => {
  try {
    const response = await axiosInstance.post('/publicCompanies/company/onboard', onboardingData);
    
    console.log("TPO onboarding created:", response.data);
    toast.success("TPO onboarding completed successfully");
    return response.data;
    
  } catch (error: any) {
    console.error("Failed to create TPO onboarding:", error.response?.data?.message);
    
    // Handle specific error cases
    if (error.response?.status === 409) {
      toast.error("TPO onboarding already exists");
    } else if (error.response?.status === 400) {
      toast.error("Invalid onboarding data provided");
    } else if (error.response?.status === 404) {
      toast.error("TPO not found");
    } else {
      toast.error(`Failed to create TPO onboarding: ${error.response?.data?.message || 'Unknown error'}`);
    }
    
    throw error;
  }
};
